import { makeRequest } from '../../../../lib/api';
import {
  OrderOfferStartRequest,
} from '../../api/orderOffer';

const ORDER_OFFERS_PATH = '/v1/order_offers';
const ORDER_EVACUATION_PATH = '/v1/order_evacuation';

const orderOfferController = {
  getOrderOffer: (): Promise<any> => {
    return makeRequest('get', `${ ORDER_OFFERS_PATH }`);
  },

  startOrderOffer: (request: OrderOfferStartRequest): Promise<any> => {
    // return makeRequest('post', `${ ORDER_OFFERS_PATH }/start`, request);
    return makeRequest('post', `${ ORDER_EVACUATION_PATH }/${ request.orderId }`);
  },

  restartOrderOffer: (request: OrderOfferStartRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_EVACUATION_PATH }/${ request.orderId }/restart`);
  },

  manualOrderProcessing: (request: OrderOfferStartRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_EVACUATION_PATH }/${ request.orderId }/operator`);
  },

  acceptOrderOffer: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_OFFERS_PATH }/${ orderId }/accept`);
  },

  rejectOrderOffer: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_OFFERS_PATH }/${ orderId }/reject`);
  },
};

export { orderOfferController };
